import React from 'react';
import Button from '../common/Button';
import { URLS, COMPANY_INFO } from '../../data/constants';
import equipeFoto from '../../assets/fotos-time/equipe.jpg';
import './Founder.css';

const Founder = () => {
  return (
    <section className="fundador">
      <div className="wrap">
        <img
          src={equipeFoto}
          alt="Equipe da Prana Consultoria"
        />
        <div>
          <span className="kicker fundador-kicker">Quem vai estar do seu lado</span>
          <h2>A gente não manda relatório e some.</h2>
          <p>
            A Prana se envolve como se o negócio fosse nosso, e é exatamente
            isso que nossos clientes dizem. Mergulhamos nos números, entendemos
            as pessoas e ficamos do lado até a transformação acontecer.
          </p>
          <p>
            Equipe com mais de 20 anos de experiência. Engenheiros, mestres e
            MBAs. Metodologia aplicada em +400 empresas em Juiz de Fora e região.
          </p>
          <div className="fundador-nome">
            {COMPANY_INFO.founder} e a equipe {COMPANY_INFO.name} · {COMPANY_INFO.tagline}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Founder;
